import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { IAppState } from '../../../common/state';
import { AB_COWORKING_POPUP_EXPERIMENT } from '../../../constants/coworkingsExperiment';
import { isAbUseExperimentGroup } from '../../../utils/experiments/isAbUseExperimentGroup';
import { isOfficeRentSearch } from '../../../utils/isOfficeRentSearch';

const LOCAL_STORAGE_COWORKING_AD_MODAL_MINI_ITEM = 'isCoworkingAdModalMiniClosed';

// ACTION TYPES
export const COWORKING_AD_MODAL_MINI_OPENED = 'modals/coworking_modal_mini_ad/MODAL_OPENED';
export const COWORKING_AD_MODAL_MINI_CLOSED = 'modals/coworking_modal_mini_ad/MODAL_CLOSED';
export const OFFERS_SCROLLED_TO_TOP = 'offersScrolledToTop';

// ACTIONS
export interface ICoworkingAdModalMiniOpened {
  type: typeof COWORKING_AD_MODAL_MINI_OPENED;
}
export interface ICoworkingAdModalMiniClosed {
  type: typeof COWORKING_AD_MODAL_MINI_CLOSED;
}
export interface IOffersScrolledToTop {
  type: typeof OFFERS_SCROLLED_TO_TOP;
}

export type TCoworkingAdModalMiniActions = ICoworkingAdModalMiniOpened | ICoworkingAdModalMiniClosed;

export const openCoworkingAdModalMini = (): ICoworkingAdModalMiniOpened => ({ type: COWORKING_AD_MODAL_MINI_OPENED });
export const closedCoworkingAdModalMini = (): ICoworkingAdModalMiniClosed => ({
  type: COWORKING_AD_MODAL_MINI_CLOSED,
});
export const setOffersScrolledToTop = (): IOffersScrolledToTop => ({ type: OFFERS_SCROLLED_TO_TOP });

// SAGAS
export function* handleOffersScrolledToTop() {
  const {
    logger,
    filters: { jsonQuery },
  } = (yield select()) as IAppState;

  if (document) {
    const uxFeedComponent = document.querySelector('.uxs-slide-back');

    if (uxFeedComponent) {
      return;
    }
  }

  try {
    const isCoworkingAdModalMiniClosed = localStorage.getItem(LOCAL_STORAGE_COWORKING_AD_MODAL_MINI_ITEM);

    if (isOfficeRentSearch(jsonQuery) && isCoworkingAdModalMiniClosed !== 'true') {
      yield put(openCoworkingAdModalMini());
    }
  } catch (error) {
    logger.warning(error, {
      description: 'Попытка обращения к localStorage',
      domain: 'handleOffersScrolledToTop',
      message: 'Ошибка при чтении данных из localStorage',
    });
  }
}

export function* handleCoworkingADModalMiniClosed() {
  const { logger } = (yield select()) as IAppState;

  try {
    localStorage.setItem(LOCAL_STORAGE_COWORKING_AD_MODAL_MINI_ITEM, 'true');
  } catch (error) {
    logger.warning(error, {
      description: 'Попытка обращения к localStorage',
      domain: 'handleOffersScrolledToTop',
      message: 'Ошибка призаписи данных в localStorage',
    });
  }
}

export function* coworkingAdModalMiniSagas() {
  const { abUseExperiments, isCoworkingExperimentsEnabled } = (yield select()) as IAppState;

  const isExperimentEnabled: boolean = yield call(
    isAbUseExperimentGroup,
    abUseExperiments,
    AB_COWORKING_POPUP_EXPERIMENT,
    'C',
  );

  if (!isCoworkingExperimentsEnabled || !isExperimentEnabled) {
    return;
  }

  yield all([
    takeLatest(OFFERS_SCROLLED_TO_TOP, handleOffersScrolledToTop),
    takeLatest(COWORKING_AD_MODAL_MINI_CLOSED, handleCoworkingADModalMiniClosed),
  ]);
}

// REDUCER
export interface ICoworkingAdModalMini {
  isOpen: boolean;
}

export const initialState = {
  isOpen: false,
};

export const coworkingAdModalMiniReducer = (
  state: ICoworkingAdModalMini = initialState,
  action: TCoworkingAdModalMiniActions,
): ICoworkingAdModalMini => {
  switch (action.type) {
    case COWORKING_AD_MODAL_MINI_OPENED:
      return {
        isOpen: true,
      };

    case COWORKING_AD_MODAL_MINI_CLOSED:
      return {
        isOpen: false,
      };

    default:
      return state;
  }
};
